import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

const createNewGroup = () => fromJS({
  name: '',
  nameDe: '',
  nameEn: '',
  nameFr: '',
  nameIt: '',
  nameJa: '',
  nameRu: '',
  nameZh: '',
  grootSavedSearchesSavedSearchGroups: []
})

export const initialState = fromJS({
  showGroupDialog: false,
  showDeleteGroupDialog: false,
  saving: false,
  deleting: false,
  selectedGroup: createNewGroup()
})

export default handleActions({
  [Actions.setSelectedSavedSearchGroup]: (state, { payload: group }) => state.set('selectedGroup', group),
  [Actions.showSavedSearchGroupDialog]: (state, { payload }) => state.merge({
    showGroupDialog: true,
    selectedGroup: payload || createNewGroup()
  }),
  [Actions.hideSavedSearchGroupDialog]: state => state.set('showGroupDialog', false),
  [Actions.showDeleteSavedSearchGroupDialog]: (state, { payload }) => state.merge({
    showDeleteGroupDialog: true,
    selectedGroup: payload
  }),
  [Actions.hideDeleteSavedSearchGroupDialog]: state => state.set('showDeleteGroupDialog', false),

  [Actions.saveSavedSearchGroupStart]: state => state.set('saving', true),
  [Actions.saveSavedSearchGroupError]: state => state.set('saving', false),
  [Actions.saveSavedSearchGroupSuccess]: state => state.merge({
    saving: false,
    showGroupDialog: false
  }),

  [Actions.deleteSavedSearchGroupStart]: state => state.set('deleting', true),
  [Actions.deleteSavedSearchGroupError]: state => state.set('deleting', false),
  [Actions.deleteSavedSearchGroupSuccess]: state => state.merge({
    deleting: false,
    showDeleteGroupDialog: false
  }),

  [AppActions.resetState]: () => initialState
}, initialState)
